import { RangoliChain } from "./Ornaments";
import { ScrollReveal } from "./ScrollReveal";

/**
 * Section opening — a terracotta serif numeral, a tracked sans label,
 * a run of rangoli chain, and a hairline to the margin. Behind the
 * row, the numeral repeats at architectural scale, ghosted into the
 * paper like a chapter folio. Sections that render this must be
 * `relative overflow-hidden`.
 */
export function SectionHead({
  index,
  label,
}: {
  index: string;
  label: string;
}) {
  return (
    <div className="relative">
      <span
        className="font-display pointer-events-none absolute -top-24 -right-6 leading-none text-warm-brown opacity-[0.05] select-none md:-top-32"
        style={{
          fontSize: "clamp(11rem, 22vw, 19rem)",
          letterSpacing: "-0.04em",
        }}
        aria-hidden
      >
        {index}
      </span>
      <ScrollReveal>
        <div className="flex items-center gap-4">
          <span className="verse-index">{index}</span>
          <span className="eyebrow">{label}</span>
          <RangoliChain />
          <span className="hairline h-px flex-1" aria-hidden />
        </div>
      </ScrollReveal>
    </div>
  );
}
